module.exports = __webpack_public_path__ + "static/img/dusty.e7c06cc5.png";